import { ca } from '@cian/analytics';

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №2
 */
export const trackLayoutsShown = (pageNumber: number, id: number[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'show_sopr',
    label: 'booked_similar_offers_open',
    useLastProducts: true,
    page: {
      extra: {
        id,
        pageNumber,
      },
    },
  });
};

interface ITrackLayoutClickParams {
  layoutOfferId: number;
  offerId: number;
  position: number;
}

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №5
 */
export const trackLayoutClick = ({ layoutOfferId, offerId, position }: ITrackLayoutClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_sopr',
    label: 'booked_similar_offers',
    products: [{ id: layoutOfferId }],
    page: {
      extra: {
        source_id: offerId,
        position,
      },
    },
  });
};

interface ITrackFavoriteClick {
  gaLabel: string;
  id: number;
}

/**
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1469163170
 * Событие №8
 */
export const trackFavoriteClick = ({ gaLabel, id }: ITrackFavoriteClick) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'add_from_newlist',
    label: gaLabel,
    useLastProducts: true,
    page: {
      extra: {
        source: 'similar_offers',
        id,
      },
    },
  });
};
